import { useQueryClient } from '@tanstack/react-query';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const UseInvalidateEndpoint = () => {
  const queryClient = useQueryClient();

  return (endpoint: string) => {
    queryClient.invalidateQueries({ queryKey: [endpoint] });
  };
};

export default UseInvalidateEndpoint;
